import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getMedicineEnquiryList } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/pharmacySlice";
const useFetchMedicineEnquiry = (id, page, pageSize, startDate, endDate) => {
    const dispatch = useDispatch();
    return useQuery({
        queryKey: ["getMedicineEnquiryList", id, page, pageSize, startDate, endDate],
        queryFn: () => getMedicineEnquiryList(id, page, pageSize, startDate, endDate),
        enabled: !!id || !!page || !!pageSize || !!startDate || !!endDate,
        onError: () => {
            dispatch(setError(true));
            dispatch(setLoading(false));
        },
        onSettled: () => {
            dispatch(setLoading(false));
        },
        // staleTime: Infinity, // Keep the data fresh indefinitely
        // cacheTime: 1000 * 60 * 60, // Cache the data for 1 hour
        refetchOnWindowFocus: false, // Don't refetch when window regains focus
        refetchOnReconnect: false, // Don't refetch when reconnecting
        refetchOnMount: false, // Don't refetch on component mount
    });
};

export default useFetchMedicineEnquiry;
